import * as React from "react";
import "./style.css";
export default function NewButton({ title = "", action }) {
  return (
    <button className="Button" type="button" onClick={action}>
      {title}
    </button>
  );
}
